import {SVGProps} from "react";

// Instagram glyph from the V2 footer (Figma "Icon / instagram", 78:891).
export const InstagramSvg = ({color = '#F6F4F0', ...props}: SVGProps<SVGSVGElement>) => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden {...props}>
        <path
            d="M14.6667 2.75H7.33333C4.80203 2.75 2.75 4.80203 2.75 7.33333V14.6667C2.75 17.198 4.80203 19.25 7.33333 19.25H14.6667C17.198 19.25 19.25 17.198 19.25 14.6667V7.33333C19.25 4.80203 17.198 2.75 14.6667 2.75Z"
            stroke={color} strokeWidth="1.55833"/>
        <path
            d="M11 14.6666C13.0251 14.6666 14.6667 13.025 14.6667 10.9999C14.6667 8.97487 13.0251 7.33325 11 7.33325C8.975 7.33325 7.33337 8.97487 7.33337 10.9999C7.33337 13.025 8.975 14.6666 11 14.6666Z"
            stroke={color} strokeWidth="1.55833"/>
        <path
            d="M16.0417 6.87508C16.5479 6.87508 16.9583 6.46468 16.9583 5.95841C16.9583 5.45215 16.5479 5.04175 16.0417 5.04175C15.5354 5.04175 15.125 5.45215 15.125 5.95841C15.125 6.46468 15.5354 6.87508 16.0417 6.87508Z"
            fill={color}/>
    </svg>
)
